<!--门店详情-->
<template>
    <div>

    </div>
</template>

<script>

    export default {
        name: 'H5',
        components: {
        },
        data: function () {
        },
        filter: {},
        mounted() {
            location.href = this.$route.query.url;
        },
        destroyed() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// H5.vue?66d870f4